import "core-js/modules/es.array.iterator.js";
import React from 'react';
const getViewport = () => ({
  height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
  width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
});
const vDimensions = (viewport, aspectRatio, native) => {
  const ratio = aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : 1.7777778;
  const vw = native ? Math.min(viewport.width, native.width) : viewport.width;
  const vh = native ? Math.min(viewport.height, native.height) : viewport.height;
  if (ratio > 1) {
    // Width should be greatter than height
    if (vh < vw) {
      return {
        height: vh,
        width: vh * ratio
      };
    }
    return {
      height: vh,
      width: vw
    };
  } else {
    // Height should be greatter than width
    return {
      height: vh,
      width: vw
    };
  }
};
export const useCameraDimensions = (nativeMaxDimensions, aspectRatio, vOffset) => {
  const native = React.useRef({
    height: 0,
    width: 0
  });
  const dimensions = React.useRef({
    height: 0,
    width: 0
  });
  const [dim, setDim] = React.useState({
    height: undefined,
    width: undefined
  });
  const getDimensions = () => {
    const viewport = getViewport();
    return vDimensions(vOffset ? vOffset(viewport) : viewport, aspectRatio, nativeMaxDimensions ? native.current : undefined);
  };
  React.useEffect(() => {
    const onResize = () => {
      const dims = getDimensions();
      if (dimensions.current.height !== dims.height || dimensions.current.width !== dims.width) {
        setDim({
          height: dims.height,
          width: dims.width
        });
      }
      dimensions.current = dims;
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const setNative = nativeDims => {
    native.current = nativeDims;
    const dims = getDimensions();
    setDim({
      height: dims.height,
      width: dims.width
    });
  };
  return [dim, setNative];
};